import axios from "axios";

/*
==========================
BASE URL
==========================
*/

const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://clent.scanmymemory.in";

/*
==========================
AXIOS INSTANCE
==========================
*/

const api = axios.create({
  baseURL: API_URL,
});

/*
==========================
GET TOKEN
==========================
*/

export const getAdminToken = () => {
  return localStorage.getItem("adminToken");
};

/*
==========================
CREATE RESTAURANT
==========================
*/

export const createRestaurant = async (
  formData
) => {

  try {

    const token =
      getAdminToken();

    const response =
      await api.post(
        "/admin/restaurants/restaurants2",
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

    return response.data;

  } catch (error) {

    console.error(
      "Create Restaurant Error:",
      error
    );

    throw error;

  }

};

/*
==========================
GET ALL RESTAURANTS
==========================
*/

export const getAllRestaurants =
  async () => {

    try {

      const token =
        getAdminToken();

      const response =
        await api.get(
          "/restaurants",
          {
            headers: {
              Authorization: token,
            },
          }
        );

      return response.data;

    } catch (error) {

      console.error(error);

      throw error;

    }

  };

/*
==========================
GET RESTAURANT BY ID
==========================
*/

export const getRestaurantDetails =
  async (id) => {

    try {

      const token =
        getAdminToken();

      const response =
        await api.get(
          `/restaurants/${id}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );

      return response.data;

    } catch (error) {

      console.error(error);

      throw error;

    }

  };

/*
==========================
LOGIN
==========================
*/

export const loginAdmin =
  async (email, password) => {

    try {

      const response =
        await api.post(
          "/api/admin/login2",
          {
            email,
            password,
          }
        );

      const token =
        response.data.token;

      if (token) {

        localStorage.setItem(
          "adminToken",
          token
        );

        localStorage.setItem(
          "userRole",
          response.data.admin.role
        );

      }

      return response.data;

    } catch (error) {

      console.error(
        "Login Error:",
        error
      );

      throw error;

    }

  };

/*
==========================
SIGNUP
==========================
*/

export const signupAdmin =
  async (
    username,
    email,
    password,
    role
  ) => {

    try {

      const response =
        await api.post(
          "/api/admin/signup",
          {
            username,
            email,
            password,
            role,
          }
        );

      return response.data;

    } catch (error) {

      console.error(error);

      throw error;

    }

  };

/*
==========================
LOGOUT
==========================
*/

export const logoutAdmin =
  () => {

    localStorage.removeItem(
      "adminToken"
    );

    localStorage.removeItem(
      "userRole"
    );

  };

/*
==========================
CHECK LOGIN
==========================
*/

export const isAdminLoggedIn =
  () => {

    return Boolean(
      localStorage.getItem(
        "adminToken"
      )
    );

  };

/*
==========================
EXPORT DEFAULT
==========================
*/

// export default {
//   createRestaurant,
//   getAllRestaurants,
//   getRestaurantDetails,
//   loginAdmin,
//   signupAdmin,
//   logoutAdmin,
//   isAdminLoggedIn,
//   getAdminToken,
// };